import {BaseModal, ModalFooter, ModalHeader} from "../BaseModal";
import React, {useEffect, useRef, useState} from "react";
import styled from 'styled-components';
import {Button} from "../../components/Button";
import {API} from "../../api";
import {PlatformToggle} from "../../components/PlatformToggle";
import {isMobileDevice} from "../../hooks/mobile/isMobile";
import Slider from "@appigram/react-rangeslider";
import {VolumeSliderStyle} from "../../pages/PlayerPage/components/ProgressBar/style";

const SContent =  styled.div`
    display: flex;
    flex-direction: column;
    
    label {
        margin-bottom: 10px;
    }
    
    > div.pad {
        margin-top: 16px;
    }
    
    .search {
        display: flex;
    }
    
    input {
        
        width: 400px;
    }
    
    .volume-controls {
        display: flex;
        gap: 7px;
    }
    
    .volume-container {
        width: 100%;
    }
    
    .volume-slider-container {
        position: absolute;
        top: 10px;
        
        width: 100%;
        transition: 0.2s opacity;
   }
   
   .volume-slider-container input {
        margin: 0;
        padding: 0;
   }
   
   #volume-img, #play-img {
        height: 24px;
        filter: brightness(0) invert(1);
        opacity: 1;
   }
   
   #play-img {
        cursor: pointer;
        height: 24px;
   }
   
   .controls-container {
        width: 100%;
        display: flex;
        margin-top: 10px;
        justify-content: space-between;
   
   }
   
   ${VolumeSliderStyle}
    
    
`;

const api = new API();

export function PlaybackControlModal({isOpen, setOpen, updateValues, controlVolume, setControlVolume, controlPaused, setControlPaused, isMobile=isMobileDevice()}) {

    return <BaseModal isOpen={isOpen} setOpen={setOpen}>
        <ModalHeader><span>Управление хостом</span></ModalHeader>
        <div>
            <SContent>

                <div className="volume-controls">
                    <img src="/icons/volume-up.png" id="volume-img" />
                    <div className={"volume-container"} style={{position: "relative"}}>
                        <div className="volume-slider-container" id="volume-slider">
                            <Slider
                                value={controlVolume}
                                orientation={"horizontal"}
                                step={1}
                                max={100}
                                min={0}
                                reverse={false}
                                tooltip={false}
                                onChange={(a) => {
                                    setControlVolume(a);
                                    updateValues("volume", a);
                                }}
                            />
                        </div>
                    </div>

                </div>
                <div className="controls-container">
                    <img src={"/icons/refresh_outline_28.svg"} id="play-img" onClick={() => {
                        updateValues("reload", 1);
                    }} />
                    <img src={controlPaused ?  "/icons/play_48.svg" : "/icons/pause_48.svg"} id="play-img" onClick={() => {
                        updateValues("paused", !controlPaused);
                    }}/>
                    <img id="play-img" style={{visibility: "hidden", width: "24px"}} />
                </div>
            </SContent>
        </div>
        <ModalFooter>
            <Button size="s" responsive={isMobile} isRich={false} isPrimary={false} onClick={() => setOpen(false)}>Закрыть</Button>
        </ModalFooter>

    </BaseModal>
}
